

// import {
//   Component,
//   OnDestroy
// } from '@angular/core';

// import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';
// import { Router, RouterLink } from '@angular/router';
// import { environment } from '../../../environments/environment';

// import {
//   Subject,
//   of
// } from 'rxjs';

// import {
//   debounceTime,
//   distinctUntilChanged,
//   switchMap,
//   catchError,
//   takeUntil
// } from 'rxjs/operators';

// import { ApiService } from '../../core/api.service';

// interface SlugSuggestion {
//   slug: string;
//   hostname?: string;
// }

// interface AddressCheckResponse {
//   available: boolean;
//   normalized?: string;
//   hostname?: string;
//   message?: string;
//   suggestions?: SlugSuggestion[];
// }

// @Component({
//   selector: 'app-register',
//   standalone: true,
//   imports: [
//     CommonModule,
//     FormsModule,
//     RouterLink
//   ],
//   templateUrl: './register.component.html',
//   styleUrl: './register.component.css'
// })
// export class RegisterComponent implements OnDestroy {
//   loading = false;
//   error = '';

//   checkingSlug = false;
//   slugTouched = false;
//   slugError = '';
//   slugAvailable: boolean | null = null;

//   slugSuggestions: SlugSuggestion[] = [];


//   showPassword = false;
// showConfirmPassword = false;

// confirmPassword = '';

// passwordError = '';



// hasUppercase(): boolean {
//   return /[A-Z]/
//     .test(
//       this.form.password
//     );
// }


// hasLowercase(): boolean {
//   return /[a-z]/
//     .test(
//       this.form.password
//     );
// }


// hasNumber(): boolean {
//   return /[0-9]/
//     .test(
//       this.form.password
//     );
// }


// hasSpecialCharacter(): boolean {
//   return /[!@#$%^&*(),.?":{}|<>_\-+=]/
//     .test(
//       this.form.password
//     );
// }

//   //readonly platformDomain = 'meucardapio.com.br';
// readonly platformDomain =
//   environment.platformDomain;
//   form = {
//     name: '',
//     email: '',
//     password: '',
//     restaurantName: '',
//     restaurantSlug: '',
//     whatsapp: ''
//   };

//   private readonly slugCheck$ = new Subject<string>();
//   private readonly destroy$ = new Subject<void>();

//   constructor(
//     private api: ApiService,
//     private router: Router
//   ) {
//     this.configureSlugCheck();
//   }

//   private configureSlugCheck(): void {
//     this.slugCheck$
//       .pipe(
//         debounceTime(500),
//         distinctUntilChanged(),

//         switchMap(slug => {
//           this.checkingSlug = true;
//           this.slugAvailable = null;
//           this.slugSuggestions = [];
//           this.slugError = '';

//           const encodedSlug = encodeURIComponent(slug);

//           return this.api
//             .get<AddressCheckResponse>(
//               `/restaurants/address/check?value=${encodedSlug}`
//             )
//             .pipe(
//               catchError(err => {
//                 this.checkingSlug = false;
//                 this.slugAvailable = null;
//                 this.slugSuggestions = [];

//                 this.slugError =
//                   err?.error?.message ||
//                   'Não foi possível verificar o endereço.';

//                 return of(null);
//               })
//             );
//         }),

//         takeUntil(this.destroy$)
//       )
//       .subscribe(response => {
//         this.checkingSlug = false;

//         if (!response) {
//           return;
//         }

//         this.slugAvailable = response.available;

//         this.slugSuggestions =
//           response.suggestions || [];

//         if (response.available) {
//           this.slugError = '';
//           return;
//         }

//         this.slugError =
//           response.message ||
//           'Esse endereço já está sendo usado.';
//       });
//   }

//   /**
//    * Converte o nome do restaurante em slug.
//    *
//    * Exemplo:
//    * Pizzaria do João -> pizzaria-do-joao
//    */
//   private generateSlug(value: string): string {
//     return String(value || '')
//       .normalize('NFD')
//       .replace(/[\u0300-\u036f]/g, '')
//       .toLowerCase()
//       .trim()
//       .replace(/[^a-z0-9]+/g, '-')
//       .replace(/-{2,}/g, '-')
//       .replace(/^-+|-+$/g, '')
//       .slice(0, 50);
//   }

//   onRestaurantNameChange(value: string): void {
//     this.form.restaurantName = value;

//     if (!this.slugTouched) {
//       this.form.restaurantSlug =
//         this.generateSlug(value);
//     }

//     this.prepareSlugCheck();
//   }

//   onSlugChange(value: string): void {
//     this.slugTouched = true;

//     this.form.restaurantSlug =
//       this.generateSlug(value);

//     this.prepareSlugCheck();
//   }

//   private prepareSlugCheck(): void {
//     this.slugAvailable = null;
//     this.slugSuggestions = [];
//     this.error = '';

//     if (!this.validateSlug()) {
//       this.checkingSlug = false;
//       return;
//     }

//     this.slugError = '';

//     this.slugCheck$.next(
//       this.form.restaurantSlug
//     );
//   }

//   validateSlug(): boolean {
//     const slug =
//       this.form.restaurantSlug.trim();

//     if (!slug) {
//       this.slugError =
//         'Escolha um endereço para o restaurante.';
//       return false;
//     }

//     if (slug.length < 3) {
//       this.slugError =
//         'O endereço precisa ter pelo menos 3 caracteres.';
//       return false;
//     }

//     if (slug.length > 50) {
//       this.slugError =
//         'O endereço pode ter no máximo 50 caracteres.';
//       return false;
//     }

//     if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(slug)) {
//       this.slugError =
//         'Use apenas letras, números e hífens.';
//       return false;
//     }

//     this.slugError = '';
//     return true;
//   }

//   selectSlugSuggestion(
//     suggestion: SlugSuggestion | string
//   ): void {
//     const slug =
//       typeof suggestion === 'string'
//         ? suggestion
//         : suggestion.slug;

//     this.slugTouched = true;
//     this.form.restaurantSlug = slug;

//     this.slugAvailable = true;
//     this.slugError = '';
//     this.slugSuggestions = [];
//     this.checkingSlug = false;

//     /*
//      * Faz uma nova verificação no backend,
//      * mesmo que a sugestão tenha vindo como disponível.
//      */
//     this.slugCheck$.next(slug);
//   }

//   // register(): void {
//   //   this.error = '';

//   //   if (
//   //     !this.form.name.trim() ||
//   //     !this.form.email.trim() ||
//   //     !this.form.password
//   //   ) {
//   //     this.error =
//   //       'Preencha nome, e-mail e senha.';
//   //     return;
//   //   }

//   //   if (
//   //     !this.form.restaurantName.trim() ||
//   //     !this.form.whatsapp.trim()
//   //   ) {
//   //     this.error =
//   //       'Preencha nome do restaurante e WhatsApp.';
//   //     return;
//   //   }

//   //   if (!this.validateSlug()) {
//   //     return;
//   //   }

//   //   if (this.checkingSlug) {
//   //     this.error =
//   //       'Aguarde a verificação do endereço.';
//   //     return;
//   //   }

//   //   if (this.slugAvailable === false) {
//   //     this.slugError =
//   //       'Escolha um endereço disponível.';
//   //     return;
//   //   }

//   //   if (this.slugAvailable === null) {
//   //     this.slugError =
//   //       'Aguarde a confirmação de disponibilidade do endereço.';
//   //     return;
//   //   }

//   //   this.loading = true;

//   //   this.api.post<any>('/auth/register', {
//   //     name: this.form.name.trim(),
//   //     email: this.form.email.trim(),
//   //     password: this.form.password
//   //   }).subscribe({
//   //     next: response => {
//   //       localStorage.setItem(
//   //         'cardapio_token',
//   //         response.token
//   //       );

//   //       localStorage.setItem(
//   //         'cardapio_user',
//   //         JSON.stringify(response.user)
//   //       );

//   //       this.createRestaurant();
//   //     },

//   //     error: err => {
//   //       this.loading = false;

//   //       this.error =
//   //         err?.error?.message ||
//   //         'Erro ao criar conta.';
//   //     }
//   //   });
//   // }


//   register(): void {

//   this.error = '';
//   this.passwordError = '';



// if (!this.validatePasswords()) {
//   return;
// }


// if (!this.confirmPassword) {
//   this.passwordError =
//     'Confirme sua senha.';

//   return;
// }


//   /*
//    * DADOS DO USUÁRIO
//    */
//   if (
//     !this.form.name.trim() ||
//     !this.form.email.trim() ||
//     !this.form.password
//   ) {
//     this.error =
//       'Preencha nome, e-mail e senha.';

//     return;
//   }


//   /*
//    * TAMANHO MÍNIMO DA SENHA
//    */
//   if (
//     this.form.password.length < 6
//   ) {
//     this.passwordError =
//       'A senha precisa ter pelo menos 6 caracteres.';

//     return;
//   }


//   /*
//    * CONFIRMAÇÃO OBRIGATÓRIA
//    */
//   if (!this.confirmPassword) {

//     this.passwordError =
//       'Confirme sua senha.';

//     return;
//   }


//   /*
//    * SENHAS DIFERENTES
//    */
//   if (
//     this.form.password !==
//     this.confirmPassword
//   ) {
//     this.passwordError =
//       'As senhas não coincidem.';

//     return;
//   }


//   /*
//    * RESTAURANTE
//    */
//   if (
//     !this.form.restaurantName.trim() ||
//     !this.form.whatsapp.trim()
//   ) {
//     this.error =
//       'Preencha nome do restaurante e WhatsApp.';

//     return;
//   }


//   if (!this.validateSlug()) {
//     return;
//   }


//   if (this.checkingSlug) {

//     this.error =
//       'Aguarde a verificação do endereço.';

//     return;
//   }


//   if (
//     this.slugAvailable === false
//   ) {
//     this.slugError =
//       'Escolha um endereço disponível.';

//     return;
//   }


//   if (
//     this.slugAvailable === null
//   ) {
//     this.slugError =
//       'Aguarde a confirmação de disponibilidade do endereço.';

//     return;
//   }


//   this.loading = true;


//   /*
//    * IMPORTANTE:
//    *
//    * confirmPassword NÃO vai para
//    * o backend.
//    */
//   this.api.post<any>(
//     '/auth/register',
//     {
//       name:
//         this.form.name.trim(),

//       email:
//         this.form.email.trim(),

//       password:
//         this.form.password
//     }
//   ).subscribe({

//     next: response => {

//       localStorage.setItem(
//         'cardapio_token',
//         response.token
//       );

//       localStorage.setItem(
//         'cardapio_user',
//         JSON.stringify(
//           response.user
//         )
//       );

//       this.createRestaurant();
//     },

//     error: err => {

//       this.loading = false;

//       this.error =
//         err?.error?.message ||
//         'Erro ao criar conta.';
//     }

//   });
// }

//   private createRestaurant(): void {
//     this.api.post<any>('/restaurants', {
//       name: this.form.restaurantName.trim(),
//       slug: this.form.restaurantSlug.trim(),
//       whatsapp: this.form.whatsapp.trim(),
//       description: 'Meu cardápio digital',
//       deliveryFee: 0,
//       minimumOrder: 0
//     }).subscribe({
//       next: restaurant => {
//         this.loading = false;

//         localStorage.setItem(
//           'cardapio_restaurant',
//           JSON.stringify(restaurant)
//         );

//         this.router.navigate([
//           '/admin/restaurantes'
//         ]);
//       },

//       error: err => {
//         this.loading = false;

//         const errorCode =
//           err?.error?.code;

//         if (
//           errorCode ===
//           'RESTAURANT_ADDRESS_ALREADY_USED'
//         ) {
//           this.slugAvailable = false;

//           this.slugError =
//             'Esse endereço já está sendo usado. Escolha outro.';

//           return;
//         }

//         if (
//           errorCode ===
//           'INVALID_RESTAURANT_ADDRESS'
//         ) {
//           this.slugAvailable = false;

//           this.slugError =
//             err?.error?.message ||
//             'Esse endereço não é válido.';

//           return;
//         }

//         this.error =
//           err?.error?.message ||
//           'Conta criada, mas houve erro ao criar o restaurante.';
//       }
//     });
//   }





// togglePasswordVisibility(): void {
//   this.showPassword =
//     !this.showPassword;
// }


// toggleConfirmPasswordVisibility(): void {
//   this.showConfirmPassword =
//     !this.showConfirmPassword;
// }

// validatePasswords(): boolean {

//   this.passwordError = '';

//   const password =
//     this.form.password;


//   if (!password) {
//     return false;
//   }


//   if (password.length < 8) {
//     this.passwordError =
//       'A senha precisa ter pelo menos 8 caracteres.';

//     return false;
//   }


//   if (!/[A-Z]/.test(password)) {
//     this.passwordError =
//       'A senha precisa ter pelo menos uma letra maiúscula.';

//     return false;
//   }


//   if (!/[a-z]/.test(password)) {
//     this.passwordError =
//       'A senha precisa ter pelo menos uma letra minúscula.';

//     return false;
//   }


//   if (!/[0-9]/.test(password)) {
//     this.passwordError =
//       'A senha precisa ter pelo menos um número.';

//     return false;
//   }


//   if (!/[!@#$%^&*(),.?":{}|<>_\-+=]/.test(password)) {
//     this.passwordError =
//       'A senha precisa ter pelo menos um caractere especial.';

//     return false;
//   }


//   if (!this.confirmPassword) {
//     return true;
//   }


//   if (
//     password !==
//     this.confirmPassword
//   ) {
//     this.passwordError =
//       'As senhas não coincidem.';

//     return false;
//   }


//   return true;
// }







//   ngOnDestroy(): void {
//     this.destroy$.next();
//     this.destroy$.complete();
//     this.slugCheck$.complete();
//   }
// }





import {
  Component,
  OnDestroy
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  Router,
  RouterLink
} from '@angular/router';

import { environment } from '../../../environments/environment';

import {
  Subject,
  of
} from 'rxjs';

import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  catchError,
  takeUntil
} from 'rxjs/operators';

import { ApiService } from '../../core/api.service';


interface SlugSuggestion {
  slug: string;
  hostname?: string;
}


interface AddressCheckResponse {
  available: boolean;
  normalized?: string;
  hostname?: string;
  message?: string;
  suggestions?: SlugSuggestion[];
}


@Component({
  selector: 'app-register',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule,
    RouterLink
  ],

  templateUrl:
    './register.component.html',

  styleUrl:
    './register.component.css'
})
export class RegisterComponent
  implements OnDestroy {

  loading = false;
  error = '';

  checkingSlug = false;
  slugTouched = false;
  slugError = '';
  slugAvailable:
    boolean | null = null;

  slugSuggestions:
    SlugSuggestion[] = [];


  showPassword = false;
  showConfirmPassword = false;

  confirmPassword = '';

  passwordError = '';


  readonly platformDomain =
    environment.platformDomain;


  form = {
    name: '',
    email: '',
    password: '',
    restaurantName: '',
    restaurantSlug: '',
    whatsapp: ''
  };


  private readonly slugCheck$ =
    new Subject<string>();

  private readonly destroy$ =
    new Subject<void>();


  constructor(
    private api: ApiService,
    private router: Router
  ) {
    this.configureSlugCheck();
  }


  /*
   * =========================================
   * SENHA
   * =========================================
   */

  hasUppercase(): boolean {
    return /[A-Z]/
      .test(
        this.form.password
      );
  }


  hasLowercase(): boolean {
    return /[a-z]/
      .test(
        this.form.password
      );
  }


  hasNumber(): boolean {
    return /[0-9]/
      .test(
        this.form.password
      );
  }


  hasSpecialCharacter(): boolean {
    return /[!@#$%^&*(),.?":{}|<>_\-+=]/
      .test(
        this.form.password
      );
  }


  togglePasswordVisibility(): void {
    this.showPassword =
      !this.showPassword;
  }


  toggleConfirmPasswordVisibility(): void {
    this.showConfirmPassword =
      !this.showConfirmPassword;
  }


  validatePasswords(): boolean {

    this.passwordError = '';

    const password =
      this.form.password;


    if (!password) {
      return false;
    }


    if (password.length < 8) {
      this.passwordError =
        'A senha precisa ter pelo menos 8 caracteres.';

      return false;
    }


    if (!/[A-Z]/.test(password)) {
      this.passwordError =
        'A senha precisa ter pelo menos uma letra maiúscula.';

      return false;
    }


    if (!/[a-z]/.test(password)) {
      this.passwordError =
        'A senha precisa ter pelo menos uma letra minúscula.';

      return false;
    }


    if (!/[0-9]/.test(password)) {
      this.passwordError =
        'A senha precisa ter pelo menos um número.';

      return false;
    }


    if (
      !/[!@#$%^&*(),.?":{}|<>_\-+=]/
        .test(password)
    ) {
      this.passwordError =
        'A senha precisa ter pelo menos um caractere especial.';

      return false;
    }


    if (!this.confirmPassword) {
      return true;
    }


    if (
      password !==
      this.confirmPassword
    ) {
      this.passwordError =
        'As senhas não coincidem.';

      return false;
    }


    return true;
  }


  /*
   * =========================================
   * SLUG
   * =========================================
   */

  private configureSlugCheck(): void {

    this.slugCheck$
      .pipe(

        debounceTime(500),

        distinctUntilChanged(),

        switchMap(slug => {

          this.checkingSlug = true;

          this.slugAvailable =
            null;

          this.slugSuggestions =
            [];

          this.slugError =
            '';


          const encodedSlug =
            encodeURIComponent(
              slug
            );


          return this.api
            .get<AddressCheckResponse>(
              `/restaurants/address/check?value=${encodedSlug}`
            )
            .pipe(

              catchError(err => {

                this.checkingSlug =
                  false;

                this.slugAvailable =
                  null;

                this.slugSuggestions =
                  [];

                this.slugError =
                  err?.error?.message ||
                  'Não foi possível verificar o endereço.';

                return of(null);
              })

            );

        }),

        takeUntil(
          this.destroy$
        )

      )
      .subscribe(response => {

        this.checkingSlug =
          false;


        if (!response) {
          return;
        }


        this.slugAvailable =
          response.available;


        this.slugSuggestions =
          response.suggestions ||
          [];


        if (
          response.available
        ) {

          this.slugError =
            '';

          return;
        }


        this.slugError =
          response.message ||
          'Esse endereço já está sendo usado.';

      });
  }


  private generateSlug(
    value: string
  ): string {

    return String(
      value || ''
    )
      .normalize('NFD')
      .replace(
        /[\u0300-\u036f]/g,
        ''
      )
      .toLowerCase()
      .trim()
      .replace(
        /[^a-z0-9]+/g,
        '-'
      )
      .replace(
        /-{2,}/g,
        '-'
      )
      .replace(
        /^-+|-+$/g,
        ''
      )
      .slice(
        0,
        50
      );
  }


  onRestaurantNameChange(
    value: string
  ): void {

    this.form.restaurantName =
      value;


    if (
      !this.slugTouched
    ) {

      this.form.restaurantSlug =
        this.generateSlug(
          value
        );
    }


    this.prepareSlugCheck();
  }


  onSlugChange(
    value: string
  ): void {

    this.slugTouched =
      true;


    this.form.restaurantSlug =
      this.generateSlug(
        value
      );


    this.prepareSlugCheck();
  }


  private prepareSlugCheck(): void {

    this.slugAvailable =
      null;

    this.slugSuggestions =
      [];

    this.error =
      '';


    if (
      !this.validateSlug()
    ) {

      this.checkingSlug =
        false;

      return;
    }


    this.slugError =
      '';


    this.slugCheck$.next(
      this.form.restaurantSlug
    );
  }


  validateSlug(): boolean {

    const slug =
      this.form.restaurantSlug
        .trim();


    if (!slug) {

      this.slugError =
        'Escolha um endereço para o restaurante.';

      return false;
    }


    if (
      slug.length < 3
    ) {

      this.slugError =
        'O endereço precisa ter pelo menos 3 caracteres.';

      return false;
    }


    if (
      slug.length > 50
    ) {

      this.slugError =
        'O endereço pode ter no máximo 50 caracteres.';

      return false;
    }


    if (
      !/^[a-z0-9]+(?:-[a-z0-9]+)*$/
        .test(slug)
    ) {

      this.slugError =
        'Use apenas letras, números e hífens.';

      return false;
    }


    this.slugError =
      '';

    return true;
  }


  selectSlugSuggestion(
    suggestion:
      SlugSuggestion |
      string
  ): void {

    const slug =
      typeof suggestion ===
      'string'

        ? suggestion

        : suggestion.slug;


    this.slugTouched =
      true;


    this.form.restaurantSlug =
      slug;


    this.slugAvailable =
      true;


    this.slugError =
      '';


    this.slugSuggestions =
      [];


    this.checkingSlug =
      false;


    this.slugCheck$.next(
      slug
    );
  }


  /*
   * =========================================
   * WHATSAPP
   * =========================================
   */

  onWhatsappChange(
    value: string
  ): void {

    let numbers =
      String(
        value || ''
      )
        .replace(
          /\D/g,
          ''
        );


    /*
     * Se o usuário colar:
     *
     * 5581999999999
     *
     * removemos o 55,
     * pois ele aparece fixo
     * na interface.
     */
    if (
      numbers.startsWith('55') &&
      numbers.length > 11
    ) {

      numbers =
        numbers.substring(2);
    }


    /*
     * Mantém apenas:
     *
     * DDD + número
     *
     * Ex:
     * 81999999999
     */
    numbers =
      numbers.substring(
        0,
        11
      );


    if (!numbers) {

      this.form.whatsapp =
        '';

      return;
    }


    if (
      numbers.length <= 2
    ) {

      this.form.whatsapp =
        `(${numbers}`;

      return;
    }


    const ddd =
      numbers.substring(
        0,
        2
      );


    const phone =
      numbers.substring(2);


    if (
      phone.length <= 5
    ) {

      this.form.whatsapp =
        `(${ddd}) ${phone}`;

      return;
    }


    this.form.whatsapp =
      `(${ddd}) ${phone.substring(
        0,
        5
      )}-${phone.substring(
        5,
        9
      )}`;
  }


  private getWhatsappNumbers():
    string {

    return String(
      this.form.whatsapp ||
      ''
    )
      .replace(
        /\D/g,
        ''
      );
  }


  private getWhatsappForApi():
    string {

    const numbers =
      this.getWhatsappNumbers();


    return `55${numbers}`;
  }


  private validateWhatsapp():
    boolean {

    const numbers =
      this.getWhatsappNumbers();


    /*
     * Formato esperado:
     *
     * DDD + celular
     *
     * 81 99999-9999
     *
     * Total: 11 números
     */
    if (
      numbers.length !== 11
    ) {

      this.error =
        'Informe um WhatsApp válido com DDD. Ex: (81) 99999-9999';

      return false;
    }


    /*
     * Depois do DDD,
     * celulares brasileiros
     * começam com 9.
     */
    if (
      numbers.charAt(2) !==
      '9'
    ) {

      this.error =
        'Informe um número de celular válido. Ex: (81) 99999-9999';

      return false;
    }


    return true;
  }


  /*
   * =========================================
   * CADASTRO
   * =========================================
   */

  register(): void {

    this.error =
      '';

    this.passwordError =
      '';


    /*
     * SENHA
     */
    if (
      !this.validatePasswords()
    ) {
      return;
    }


    if (
      !this.confirmPassword
    ) {

      this.passwordError =
        'Confirme sua senha.';

      return;
    }


    /*
     * DADOS DO USUÁRIO
     */
    if (
      !this.form.name.trim() ||
      !this.form.email.trim() ||
      !this.form.password
    ) {

      this.error =
        'Preencha nome, e-mail e senha.';

      return;
    }


    /*
     * RESTAURANTE
     */
    if (
      !this.form.restaurantName
        .trim() ||
      !this.form.whatsapp
        .trim()
    ) {

      this.error =
        'Preencha nome do restaurante e WhatsApp.';

      return;
    }


    /*
     * VALIDA WHATSAPP
     */
    if (
      !this.validateWhatsapp()
    ) {
      return;
    }


    /*
     * VALIDA SLUG
     */
    if (
      !this.validateSlug()
    ) {
      return;
    }


    if (
      this.checkingSlug
    ) {

      this.error =
        'Aguarde a verificação do endereço.';

      return;
    }


    if (
      this.slugAvailable ===
      false
    ) {

      this.slugError =
        'Escolha um endereço disponível.';

      return;
    }


    if (
      this.slugAvailable ===
      null
    ) {

      this.slugError =
        'Aguarde a confirmação de disponibilidade do endereço.';

      return;
    }


    this.loading =
      true;


    this.api
      .post<any>(
        '/auth/register',
        {
          name:
            this.form.name
              .trim(),

          email:
            this.form.email
              .trim(),

          password:
            this.form.password
        }
      )
      .subscribe({

        next: response => {

          localStorage.setItem(
            'cardapio_token',
            response.token
          );


          localStorage.setItem(
            'cardapio_user',
            JSON.stringify(
              response.user
            )
          );


          this.createRestaurant();
        },


        error: err => {

          this.loading =
            false;


          this.error =
            err?.error?.message ||
            'Erro ao criar conta.';
        }

      });
  }


  private createRestaurant():
    void {

    this.api
      .post<any>(
        '/restaurants',
        {

          name:
            this.form.restaurantName
              .trim(),

          slug:
            this.form.restaurantSlug
              .trim(),

          /*
           * O usuário vê:
           *
           * (81) 99999-9999
           *
           * API recebe:
           *
           * 5581999999999
           */
          whatsapp:
            this.getWhatsappForApi(),

          description:
            'Meu cardápio digital',

          deliveryFee:
            0,

          minimumOrder:
            0

        }
      )
      .subscribe({

        next: restaurant => {

          this.loading =
            false;


          localStorage.setItem(
            'cardapio_restaurant',
            JSON.stringify(
              restaurant
            )
          );


          this.router.navigate([
            '/admin/restaurantes'
          ]);
        },


        error: err => {

          this.loading =
            false;


          const errorCode =
            err?.error?.code;


          if (
            errorCode ===
            'RESTAURANT_ADDRESS_ALREADY_USED'
          ) {

            this.slugAvailable =
              false;


            this.slugError =
              'Esse endereço já está sendo usado. Escolha outro.';

            return;
          }


          if (
            errorCode ===
            'INVALID_RESTAURANT_ADDRESS'
          ) {

            this.slugAvailable =
              false;


            this.slugError =
              err?.error?.message ||
              'Esse endereço não é válido.';

            return;
          }


          this.error =
            err?.error?.message ||
            'Conta criada, mas houve erro ao criar o restaurante.';
        }

      });
  }


  /*
   * =========================================
   * DESTROY
   * =========================================
   */

  ngOnDestroy(): void {

    this.destroy$.next();

    this.destroy$.complete();

    this.slugCheck$.complete();
  }
}